import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const NetworkTileTimechainReachable = ({ data, animate }) => {
  const numberValue = data
    ? 'TRUE'
    : 'Loading...';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Timechain Reachable" value={numberValue} />
    </ThemedFlex>
  );
};
